import { FilterAssetsModal } from "@features/ax/shared/filterAssetsModal";
import { useCurrency } from "@shared/selectors/globalSelectors";
import { Button } from "@shared/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Tooltip, TooltipContent, TooltipTrigger } from "@shared/ui/tooltip";
import { DollarSign, HelpCircle } from "lucide-react";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const HighMaintenanceCostAssets: React.FC<{ data: any }> = ({
  data,
}) => {
  const { id } = useParams();
  const currency = useCurrency();
  const [showCriticalAssetsModal, setShowCriticalAssetsModal] = useState(false);

  const navigate = useNavigate();

  const handleReview = (assetId: string) => {
    navigate(`/ax/asset-registry/assets/view/${assetId}`);
  };

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <div>
            <CardTitle className="text-lg flex items-center gap-2">
              <DollarSign className="h-5 w-5" />
              High Maintenance Cost Assets
            </CardTitle>
          </div>
          <div className="mt-1">
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p className="max-w-xs">
                  The assets within this system that are incurring the highest
                  maintenance and repair costs.
                </p>
              </TooltipContent>
            </Tooltip>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        {data?.proactiveAlerts?.highMaintenanceCostAssets &&
        data.proactiveAlerts.highMaintenanceCostAssets.length > 0 ? (
          <>
            <div className="space-y-3 mt-3">
              {data.proactiveAlerts.highMaintenanceCostAssets.map(
                (asset: any, index: number) => (
                  <div
                    key={asset.id}
                    className="flex items-center justify-between p-3 bg-gray-50 rounded"
                  >
                    <div>
                      <p className="font-medium">{asset.assetName || "N/A"}</p>
                      <p className="text-sm text-gray-600">
                        {asset.assetNo || "N/A"}
                      </p>
                      <p className="text-sm font-semibold text-red-600">
                        {currency} {asset.monthlyCost ?? "N/A"}
                      </p>
                    </div>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => handleReview(asset.assetId)}
                    >
                      View
                    </Button>
                  </div>
                )
              )}
            </div>

            {/* VIEW ALL BUTTON */}
            <div className="flex justify-center mt-4">
              <Button
                size="sm"
                variant="outline"
                onClick={() => setShowCriticalAssetsModal(true)}
              >
                View All
              </Button>
            </div>
          </>
        ) : (
          <div className="p-3 rounded text-center text-gray-500">
            No high maintenance cost assets found.
          </div>
        )}
      </CardContent>

      <FilterAssetsModal
        entityId={id}
        entityType={"network"}
        filterType={"high_maintenance_cost"}
        showCriticalAssetsModal={showCriticalAssetsModal}
        setShowCriticalAssetsModal={setShowCriticalAssetsModal}
        title="High Maintenance Cost Assets"
      />
    </Card>
  );
};
